import { render } from "./App.vue?vue&type=template&id=2de73419&scoped=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=2de73419&lang=scss&scoped=true"
import "./App.vue?vue&type=style&index=1&id=2de73419&lang=scss"
script.render = render
script.__scopeId = "data-v-2de73419"

export default script